import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectClient } from '@client/model';
import {
  BuildPolicyDetailsInput,
  PolicyDetailsModel,
  buildPolicyDetails,
} from '../components/policyDetails/buildPolicyDetails';

/**
 * Memoized model for the policy details card. The build is pure
 * data-transformation (no React), so memoization is just a cache.
 */
export function usePolicyDetails(
  input: Omit<BuildPolicyDetailsInput, 'clientHasStartedLtc'>,
): PolicyDetailsModel {
  const {
    intakeSurvey: { clientHasStartedLtc },
  } = useSelector(selectClient);
  return useMemo(
    () => buildPolicyDetails({ ...input, clientHasStartedLtc }),
    [input.policy, clientHasStartedLtc],
  );
}
